import { ReactNode } from 'react';
import { Icon } from '../../atoms/Icon';
import { Typography } from '../../molecules/Typography';
import { useAccessControlStore } from '../../../stores/accessControlStore';
import { getSalesLink } from '../../../accessControl/salesLink';

interface ILockedContent {
  /** Quando true, borra o conteúdo e mostra o upsell. */
  locked: boolean;
  children: ReactNode;
  className?: string;
  /** Texto exibido sobre o conteúdo borrado. */
  label?: string;
  /** Versão reduzida do overlay, para cards baixos/estreitos. */
  compact?: boolean;
}

/**
 * Bloqueia um conteúdo: borra, desabilita a interação e mostra um upsell que
 * redireciona direto para a página de vendas. Desbloqueado, renderiza normal.
 */
export default function LockedContent({
  locked,
  children,
  className,
  label = 'Quer ir além?',
  compact = false,
}: ILockedContent) {
  const platformModules = useAccessControlStore(
    (state) => state.platformModules
  );

  if (!locked) {
    // Mantém o mesmo box nos dois estados quando há className de layout,
    // para não perder margens/dimensões ao liberar o acesso.
    return className ? (
      <div className={className}>{children}</div>
    ) : (
      <>{children}</>
    );
  }

  const goToSales = () => {
    window.open(getSalesLink(platformModules), '_blank');
  };

  return (
    <div className={`relative h-full overflow-hidden ${className ?? ''}`}>
      <div
        className='pointer-events-none h-full select-none blur-sm'
        aria-hidden
      >
        {children}
      </div>

      <button
        type='button'
        onClick={goToSales}
        className={`absolute inset-0 flex flex-col items-center justify-center bg-mono-color-black/50 ${
          compact ? 'gap-0.5 px-2' : 'gap-2'
        }`}
      >
        <Icon
          type='material'
          Icon='lock'
          className={`text-color-lightest drop-shadow ${compact ? 'text-lg' : 'text-3xl'}`}
        />
        <Typography
          weight='bold'
          size={compact ? 'small' : 'default'}
          className='text-center text-color-lightest drop-shadow'
        >
          {label}
        </Typography>
        <Typography
          size={compact ? 'mini' : 'small'}
          className='text-center text-color-lightest drop-shadow'
        >
          Desbloqueie todos os recursos da Aprova Total e tenha uma experiência
          completa.
        </Typography>
      </button>
    </div>
  );
}
